/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useCallback, useContext, useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import debounce from "lodash.debounce";
import { useAuth } from "cms/auth/hooks/use-auth";
import { useSelectFieldSchema } from "cms/fields/dynamic-field";
import { WebpageSelectorWrapper } from "cms/fields/fields/field-webpage-ref/edit/webpage-selector-wrapper";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";

const WebpageRefFieldEdit = () => {
    
    const { token } = useAuth();
    const {
        name,
        index,
        value,
        settings,
        updateListItem,
        disabled = false
    } = useContext(ListItemContext);
    
    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { options: schemaOptions, } = schemaSettings || {};
    const { filter, filterValue } = schemaOptions || {};
    const [webpage, setWebpage] = useState();
    const [itemLocalState, setItemLocalState] = useState({ value, settings });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 1200),
        [updateListItem]
    );
    
    const onWebpageChange = (webpage) => {
        setWebpage(webpage);
        const updatedState = {
            ...itemLocalState,
            value: webpage?.guid
        };
        setItemLocalState(updatedState);
        update(updatedState,index);
    };
    
    const onWebpageRemove = () => {
        setWebpage(undefined);
        const updatedState = {
            ...itemLocalState,
            value: undefined
        };
        setItemLocalState(updatedState);
        update(updatedState,index);
    };
    
    useEffect(() => {
        async function fetchData () {
            const webpage_guid = itemLocalState.value;
            if (webpage_guid) {
                const webpage = await SimpliCityAdminSDK.webpage.findOne(token, webpage_guid);
                if (webpage && webpage.guid) {
                    setWebpage(webpage);
                }
            }
        }
        if (itemLocalState.value) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemLocalState.value]);
    
    return (
        <div className='simplicity-composer-field-primary-layout'>
            {/*<div className='simplicity-composer-field-primary'>*/}
            {/*  Edit Model Value  */}
            <WebpageSelectorWrapper
                filter={filter}
                filterValue={filterValue}
                webpage={webpage}
                onWebpageChange={onWebpageChange}
                onWebpageRemove={onWebpageRemove}
                disabled={disabled}
            />
            {/*</div>*/}
        </div>
    );
};
export { WebpageRefFieldEdit };
